/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListTemplateFolder } from '../../models/api-response-list-template-folder';

export interface ListTemplateFolder$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function listTemplateFolder(http: HttpClient, rootUrl: string, params: ListTemplateFolder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTemplateFolder>> {
  const rb = new RequestBuilder(rootUrl, listTemplateFolder.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListTemplateFolder>;
    })
  );
}

listTemplateFolder.PATH = '/v1/api/ui/templateFolder/list';
